import React, { useEffect } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

import CardBeneficios from "../components/CardBeneficios";

import Switcher from "../components/switcher";
import VideoBackground from "../components/VideoBackground";
import useStore from "../store/useStore";
import VideoComex from "../components/VideoComex";
import Productos from "../components/Productos";
const productos = [
  {
    title: "100% Compliance",
    description:
      "Prevención de riesgos legales al mantener actualizado a la normativa todo el proceso de importación/exportación.",
  },
  {
    title: "Reducción de costos",
    description:
      "Minimización de errores al automatizar cargas documentales y setear procedimientos automatizados.",
  },
  {
    title: "Velocidad",
    description:
      "Tecnología robusta para soportar el procesamiento de grandes volúmenes de datos.",
  },
];
const producto1 = [
  {
    title: "RAF ",
    description:
      "Optimizamos procesos, logrando mitigar riesgos en las operaciones logísticas de transporte marítimo, aéreo y terrestre. Brindamos cotizaciones en el acto, evitando las pérdidas de tiempo.",
    img: "",
  },
  {
    title: "Repo Stock ",
    description:
      "Nuestra tecnología ofrece una solución integral y sin complicaciones para contratar seguros de contenedores, garantizando su estado óptimo y devolución puntual.",
    img: "",
  },
  {
    title: "Anexo 24 ",
    description:
      "Diseñamos un producto que permite a nuestros clientes ofrecer garantías ininterrumpidas las 24 horas, los 7 días de la semana, con las condiciones más favorables.",
    img: "",
  },
  {
    title: "MAQUILA",
    description:
      "Agilizamos los procesos en el gerenciamiento de riesgo, trabajando con partners líderes en la región y garantizando la seguridad para mover tu mercadería o la de tus clientes.",
    img: "",
  },
];
export default function Mre() {
  const { mreHeroes, getMreHeroes } = useStore();
  const urlApi = "https://api.institucional.global.sidom.io";

  useEffect(() => {
    getMreHeroes();
  }, [getMreHeroes]);
  return (
    <>
      <header>
        <Navbar />
      </header>
      <main className="bg-sidom-light dark:bg-sidom-blue text-sidom-dark dark:text-sidom-light">
        <section>
          {mreHeroes?.length === 0 || !mreHeroes ? (
            <VideoBackground
              video="/placeholder.mp4"
              titulo1="Cargando..."
              titulo2="Espere un momento"
              textbutton="SOLICITAR DEMO"
              logo="/placeholder-logo.png"
            />
          ) : (
            mreHeroes.map((item, index) => (
              <VideoBackground
                key={index}
                video={`${urlApi}${item.video[0]?.url}`}
                titulo1={item.titulo}
                titulo2={item.text}
                textbutton="SOLICITAR DEMO"
                link={"/contact"}
                logo={`${urlApi}${
                  item.img[0]?.formats?.thumbnail?.url ||
                  item.img?.url ||
                  "/placeholder-logo.png"
                }`}
              />
            ))
          )}
        </section>
        <section>
          <VideoComex />
        </section>
        <section className="container  mb-[100px]">
          <div className="flex flex-col h-full">
            <h2 className="text-sidom-orange mt-[100px]  mb-[60px] text-4xl md:text-5xl font-extrabold text-left ">
              Beneficios
            </h2>
            <div>
              {productos.map((producto, index) => (
                <CardBeneficios
                  key={index}
                  titulo={producto.title}
                  descripcion={producto.description}
                />
              ))}
            </div>
          </div>
        </section>
        <section>
          <section className=" mb-[100px]">
            <div className="container">
              <Productos productos={producto1} />
            </div>
          </section>
        </section>
      </main>
      <footer>
        <Footer />
      </footer>

      <Switcher />
    </>
  );
}
